module.exports = __webpack_public_path__ + "img/play-1.b29dd0ec.png";